<template>
    <div class="dynamic-content">
        <h1 class="page-title">Compliance Standards & User Protection</h1>

        <p class="desc-text">XigFor operates in accordance with applicable platform policies and regulatory requirements.</p>
        <p class="desc-text section-spacing">We are committed to maintaining a safe, fair, and compliant marketplace environment.</p>

        <div class="content-section">
            <h2 class="section-title">Platform Compliance</h2>
            <p class="desc-text">XigFor follows the applicable guidelines of:</p>
            <ul class="bullet-list">
                <li>• Apple App Store</li>
                <li>• Google Play</li>
                <li>• Payment service providers</li>
            </ul>
        </div>

        <div class="content-section">
            <h2 class="section-title">User Safety</h2>
            <p class="desc-text">We implement measures to:</p>
            <ul class="bullet-list">
                <li>• Prevent misuse of platform features</li>
                <li>• Protect users from fraudulent activity</li>
                <li>• Enforce community and marketplace rules</li>
            </ul>
        </div>

        <!-- <div class="bottom-links">
            <div class="link-item">
                <router-link to="/content/platform-disclaimer" class="action-link">Compliance Standards & User Protection</router-link>
                <span class="arrow-icon">></span>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'ComplianceStandards'
}
</script>

<style scoped>
@import './shared-info-styles.css';
</style>
